import React from "react";
import logoBlack from "../assets/logo-black.png";

const DeleteAccount = () => {
  return (
    <div style={styles.page}>
      {/* ✅ HEADER */}
      <div style={styles.header}>
        <img src={logoBlack} alt="Conquer Life Logo" style={styles.logo} />
        <h1 style={styles.headerTitle} className="text-big-heading">
          CONQUER LIFE
        </h1>
      </div>
      {/* ✅ CONTENT */}
      <div style={styles.container}>
        <h1 style={styles.heading} className="text-big-heading">
          Delete Your Account
        </h1>
        <p className="text-body">
          This page explains how to request deletion of your Conquer Life
          account and the data associated with it. The Conquer Life app is
          developed and operated by Conquer Life Co.
        </p>

        <h2 className="text-heading">How to delete your account</h2>
        <h3 className="text-sub-heading">From inside the app</h3>
        <ol className="text-body">
          <li>Open the Conquer Life app and sign in.</li>
          <li>Tap the Menu in the top left corner.</li>
          <li>Go to App Settings.</li>
          <li>Tap “Delete Account”.</li>
          <li>
            Confirm the one-time passcode (OTP) sent to the phone number or
            email address registered to your account.
          </li>
        </ol>
        <p className="text-body">
          Once you confirm, your account is deleted immediately. No further
          action is required.
        </p>

        <h3 className="text-sub-heading">If you cannot sign in</h3>
        <p className="text-body">
          Email us at <a href="mailto:info@conquerlife.io">info@conquerlife.io</a>{" "}
          with the subject “Delete my account”, from the email address
          registered to your account or including the phone number registered to
          it. We will verify your identity and delete the account on your
          behalf.
        </p>

        <h2 className="text-heading">What data is deleted</h2>
        <p className="text-body">
          When you delete your account, all personal information associated with
          your profile is permanently removed from our app. This includes your
          username, the email address and phone number used to sign in, your
          bio, your interests and personality traits, and your messages. Your
          profile will no longer be visible to other users.
        </p>

        <h2 className="text-heading">What data is kept</h2>
        <p className="text-body">
          We do not keep your data after your account is deleted.
        </p>
        <p className="text-body">
          Deletion is immediate and cannot be undone — your profile cannot be
          restored once deleted. If you sign up again after deleting your
          account, it will be treated as an entirely new account.
        </p>
        <p className="text-body">
          Please be aware that while we remove your data from our systems,
          copies of information may still be accessible if it has previously
          been shared with others or stored by third parties.
        </p>

        <h2 className="text-heading">More information</h2>
        <p className="text-body">
          For full details on how we handle your data, see our{" "}
          <a href="/privacy-policy">Privacy Policy</a> and{" "}
          <a href="/terms-and-conditions">Terms &amp; Conditions</a>.
        </p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    flex: 1,
    backgroundColor: "#FFFFFF",
  },
  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid black",
    height: "60px",
    padding: "0 15px",
    boxSizing: "border-box",
  },
  logo: {
    width: "40px",
    height: "40px",
    marginRight: "15px",
  },
  headerTitle: {
    fontSize: "26px",
    fontWeight: "bold",
    color: "black",
    margin: 0,
  },
  container: {
    padding: "2rem",
  },
  heading: {
    textAlign: "center",
    fontSize: "2.5rem",
    color: "#333",
    marginBottom: "2rem",
  },
};

export default DeleteAccount;
